module.exports = __webpack_public_path__ + "static/logo-full-46e3c9f5d18f2e9557d10cd2808618f9.png";